export const addEmail = (email, selector) => {
  const emailElement = document.querySelector(selector);

  if (emailElement) {
    emailElement.setAttribute('href', 'mailto:' + email)
    emailElement.innerHTML = email;
  }
}